import { createSystem, defaultConfig, defineConfig } from 'tcm-chakra-ui'

const config = defineConfig({
  /**
   * Unique prefix so Chakra v3 tokens (`--tcm-*`) do not collide with the RM
   * shell (Chakra v2) or any other global `--chakra-*` usage on `html`.
   */
  cssVarsPrefix: 'tcm',
  /** Scope `--tcm-*` to the TCM subtree only; do not attach to `html` (avoids mixing with v2). */
  cssVarsRoot: '.tcm-chakra-root',
  /** Avoid v3 preflight resets conflicting with the RM v2 shell. */
  preflight: false,
  theme: {
    tokens: {
      fonts: {
        heading: { value: 'Inter, sans-serif' },
        body: { value: 'Inter, sans-serif' },
      },
      colors: {
        /** Chakra `colorPalette="brand"` scale — primary actions (solid uses ~500/600) */
        brand: {
          50: { value: '#E8EEF7' },
          100: { value: '#C5D4EC' },
          200: { value: '#9FB8DE' },
          300: { value: '#7A9CD0' },
          400: { value: '#4E7FC2' },
          500: { value: '#3175CE' },
          600: { value: '#2C4E82' },
          700: { value: '#1A305D' },
          800: { value: '#0a162e' },
          900: { value: '#050d1f' },
          950: { value: '#030910' },
        },
        background: {
          brandLight: { value: '#3175CE' },
          brandDark: { value: '#1A305D' },
          primary: { value: '#FFFFFF' },
          secondary: { value: '#E2E8F0' },
          surfaceTertiary: { value: '#F7FAFC' },
          surfaceSuccess: { value: '#38A169' },
          surfaceError: { value: '#C53030' },
        },
        border: {
          gray: { value: '#CBD5E0' },
          subtle: { value: '#E2E8F0' },
        },
        text: {
          primary: { value: '#2D3748' },
          secondary: { value: '#4A5568' },
          brandDark: { value: '#1A305D' },
          brandLight: { value: '#3175CE' },
          white: { value: '#FFFFFF' },
        },
      },
    },
  },
})

export const system = createSystem(defaultConfig, config)
